/**
 * Runs `run` while holding the named Web Lock, so only one browser tab at a time does it. Where the
 * Web Locks API is missing it just runs; callers still coordinate within their own tab.
 */
export function exclusive<T>(name: string, run: () => Promise<T>): Promise<T> {
	const locks = globalThis.navigator?.locks;
	return locks ? locks.request(name, run) : run();
}
